import {
  FormGroup,
  FormLabel,
  StyledSelect,
  TemplateTextarea,
  TextInput,
  MobilePhoneInput,
  EmailInput,
  FormError,
} from "@components";

export const MessageTemplateFields = ({
  control,
  errors = {},
  templates,
  smsSelected,
  emailSelected,
  isSingleRequest = false,
  isInvoice = false,
}) => (
  <>
    {/* Template dropdown */}
    {templates && (smsSelected || emailSelected) && (
      <FormGroup className="p-5 mb-0">
        <FormLabel>Message template</FormLabel>
        <StyledSelect
          name="template"
          control={control}
          options={[
            { label: "None", value: "none", key: "none" },
            ...templates.map((t) => ({
              label: t.name,
              value: t.id,
              key: t.id,
            })),
          ]}
        />
      </FormGroup>
    )}

    {/* SMS message */}
    {smsSelected && (
      <>
        <div className="p-5 border-t">
          {isSingleRequest && (
            <FormGroup className="pb-5 mb-0">
              <FormLabel>SMS number</FormLabel>
              <MobilePhoneInput
                name="phone"
                control={control}
                required
                errors={errors.phone}
                displayName="SMS number"
              />
              <FormError name="phone" errors={errors} className="static p-1" />
            </FormGroup>
          )}
          <FormGroup className="mb-0">
            <FormLabel>SMS message template</FormLabel>
            <TemplateTextarea
              name="smsMessage"
              control={control}
              displayName="SMS message template"
              placeholder="SMS message template"
              className="min-h-36"
              required
              invalid={!!errors?.smsMessage}
              blacklistedTokens={
                isSingleRequest && !isInvoice ? ["{invoices_requested}"] : []
              }
            />
            <FormError
              name="smsMessage"
              errors={errors}
              className="static p-1"
            />
          </FormGroup>
        </div>
      </>
    )}

    {/* Email subject + body */}
    {emailSelected && (
      <>
        <div className="border-t p-5">
          {isSingleRequest && (
            <FormGroup className="pb-5 mb-0">
              <FormLabel>Email address</FormLabel>
              <EmailInput
                name="email"
                control={control}
                required
                errors={errors.email}
                displayName="Email address"
                placeholder="email@customer.com"
              />
              <FormError name="email" errors={errors} className="static p-1" />
            </FormGroup>
          )}
          <FormGroup className="pb-5 mb-0">
            <FormLabel>Email subject</FormLabel>
            <TextInput
              name="subject"
              control={control}
              required
              errors={errors.subject}
              displayName="Subject"
              placeholder="Email subject"
            />
          </FormGroup>
          <FormGroup className="mb-0">
            <FormLabel>Email message template</FormLabel>
            <TemplateTextarea
              name="emailBody"
              control={control}
              displayName="Email template"
              placeholder="Email template"
              className="min-h-36"
              required
              invalid={!!errors?.emailBody}
              blacklistedTokens={
                isSingleRequest && !isInvoice ? ["{invoices_requested}"] : []
              }
            />
            <FormError
              name="emailBody"
              errors={errors}
              className="static p-1"
            />
          </FormGroup>
        </div>
      </>
    )}
  </>
);
